import React, { lazy, Suspense } from 'react';

import Skeleton from './Skeleton.tsx';

// The markdown stack (react-markdown + remark/rehype plugins) is heavy, so it is
// split into its own chunk and only downloaded when a message actually needs it.
const MarkdownRenderer = lazy(() => import('./MarkdownRenderer.tsx'));

export type LazyMarkdownRendererProps = React.ComponentProps<typeof MarkdownRenderer>;

export default function LazyMarkdownRenderer(props: LazyMarkdownRendererProps) {
  return (
    <Suspense fallback={<Skeleton variant="message" count={4} />}>
      <MarkdownRenderer {...props} />
    </Suspense>
  );
}
